import React from "react";
import congratsLogo from "../../assets/images/congrats.png";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import { CongratsAIProps } from "../../types/screensTypes";
import studio from "./StudioModal.module.css";
import { ModalPortal } from "./ModalPortal";

const CongratsAI: React.FC<CongratsAIProps> = ({
    isOpen,
    onClose,
    redirectToProjectUrl,
    projectId,
    contentType = "text",
}) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    if (!isOpen) return null;

    const modaleTitle = t("done");

    // Get the appropriate message based on content type
    const getContentMessage = () => {
        switch (contentType) {
            case "cartel":
                return t("yourCartelsAreNowReady");
            case "newsletter":
                return t("yourNewslettersAreNowReady");
            case "text":
            default:
                return t("yourAudiosAreNowReady");
        }
    };

    return (
        <ModalPortal>
            <div className={studio.overlay}>
                <div className={studio.content}>
                    <div className={studio.logoWrap}>
                        <img src={congratsLogo} alt="Logo" />
                    </div>
                    <h1 className={studio.title}>{modaleTitle}</h1>
                    <p className={studio.subtitle}>{getContentMessage()}</p>
                    <div className={studio.buttonsCentered}>
                        {projectId && (
                            <Button variant="primary" label={t("goToMyProject")} onClick={redirectToProjectUrl} />
                        )}
                        <Button variant="outline" shape="pill" label={t("close")} onClick={onClose} />
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};

export default CongratsAI;
